<div class="barra-progresso-container">
  <div *ngIf="titulo" class="barra-progresso-titulo">{{ titulo }}</div>
  <div class="barra-progresso" [style.background-color]="corBarra">
    <div
      [matTooltip]="exibirDisplayReal ? null : ('COMPONENTS.METAS.progressBar.realProduced' | transloco) + ' - ' + metaReal + ' HA'"
      matTooltipPosition="above" [matTooltipDisabled]="exibirDisplayReal" class="barra-real"
      [style.width.%]="porcBarraReal" [style.background-color]="corReal"></div>

    <div
      [matTooltip]="exibirDisplayIdeal ? null : ('COMPONENTS.METAS.progressBar.idealPoint' | transloco) + ' - ' + metaIdeal + ' HA'"
      matTooltipPosition="above" [matTooltipDisabled]="exibirDisplayIdeal" class="barra-ideal"
      [style.width.%]="porcBarraIdeal" [style.background-color]="corIdeal"></div>

    <div *ngIf="exibirDisplayIdeal" class="ideal" [class]="titulo ? 'marcador-turno' : 'marcador-meta'"
      [style.left.%]="porcBarraIdeal" [style.transform]="calcularTransform(porcBarraIdeal)">
      {{ "COMPONENTS.METAS.progressBar.idealPoint" | transloco }}
    </div>

    <div *ngIf="exibirDisplayReal" class="real" [class]="titulo ? 'marcador-turno' : 'marcador-meta'"
      [style.left.%]="porcBarraReal" [style.transform]="calcularTransform(porcBarraReal)">
      <span>{{ metaReal }} HA</span>
    </div>

  </div>
  <div class="etiquetas">
    <span>0 HA</span>
    <span>{{ metaTotal }} HA</span>
  </div>
</div>